import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilesState } from "./types";
import {
  getFileContentReducerBuilder,
  uploadFileReducerBuilder,
} from "./reducers";
import { SaveFileValue } from "../../../services/api/instances/saveFileApi/types";
import { TFileTypeConfig } from "../types";

const initialState: FilesState = {
  filesValue: null,
  fileConfig: null,
  isFileLoading: false,
};

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    setFilesValue: (state, action: PayloadAction<SaveFileValue>) => {
      state.filesValue = action.payload;
    },
    setFileConfig: (state, action: PayloadAction<TFileTypeConfig | null>) => {
      state.fileConfig = action.payload;
    },
    clearFilesState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    uploadFileReducerBuilder(builder);
    getFileContentReducerBuilder(builder);
  },
});

export const filesReducers = filesSlice.reducer;
export const { setFilesValue, setFileConfig, clearFilesState } =
  filesSlice.actions;
